import React, { useContext } from 'react';
import c from 'classnames';
import CorePrice from '../../CorePrice';
import { CoreTypes } from '../../types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSelector } from 'react-redux';
import { getSale } from '../../../../redux/packagePicker/selectors';

import s from './SecondaryCTA.scss';

export interface Props {}

const SecondaryCTA: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);
  const { ppReverseOrder } = useSelector(getSale) || {};

  return (
    <div className={c(s['root'], ppReverseOrder && s['reverse-order'])}>
      {isMobile && <CorePrice coreType={CoreTypes.CORE_PRO} />}
      <CorePrice coreType={CoreTypes.CORE_ACCESS} />
      <CorePrice coreType={CoreTypes.CORE_PLUS} />
      {!isMobile && <CorePrice coreType={CoreTypes.CORE_PRO} />}
      <CorePrice coreType={CoreTypes.CORE_PRO_PLUS} />
    </div>
  );
};
SecondaryCTA.displayName = 'SecondaryCTA';

export default SecondaryCTA;
